import axiosService from '../plugins/axiosService'

export default {
    async referenceAll(){
        return axiosService.get('/api/reference/all')
    }
}
